module.exports = __webpack_public_path__ + "img/stationary-set.5f6f18ef.svg";